import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { ServiceLevelRBAC } from '../pages/ServiceLevel/rbac'
import { HubWeatherRBAC } from '../pages/HubWeather/rbac'
import { BlacklistAreaRBAC } from '../pages/BlacklistArea/rbac'
import { BlacklistAreaAddEditRBAC } from '../pages/BlacklistAreaAddEdit/rbac'
import { BlacklistAreaDetailRBAC } from '../pages/BlacklistAreaDetail/rbac'
import { GlobalScheduleCloseRBAC } from '../pages/GlobalScheduledClose/rbac'
import { CloseMessageConfigRBAC } from '../pages/CloseMessageConfig/rbac'
import { GreylistAreaRBAC } from '../pages/GreylistArea/List/rbac'
import { GreylistlistAreaDetailRBAC } from '../pages/GreylistArea/Detail/rbac'
import { GreylistAreaAddEditRBAC } from '../pages/GreylistArea/AddEdit/rbac'
import { IsochroneVersioningRBAC } from '../pages/IsochroneVersioning/rbac'
import { AdjacentHubListRBAC } from '../pages/AdjacentHub/List/rbac'

const CloseMessageConfig = lazy(() => import('../pages/CloseMessageConfig'))
const GlobalScheduledClose = lazy(() => import('../pages/GlobalScheduledClose'))
const ServiceLevel = lazy(() => import('../pages/ServiceLevel'))
const HubWeather = lazy(() => import('../pages/HubWeather'))
const BlacklistArea = lazy(() => import('../pages/BlacklistArea'))
const BlacklistAreaAddEdit = lazy(() => import('../pages/BlacklistAreaAddEdit'))
const BlacklistAreaDetail = lazy(() => import('../pages/BlacklistAreaDetail'))
const GreylistArea = lazy(() => import('../pages/GreylistArea/List'))
const GreylistAreaDetail = lazy(() => import('../pages/GreylistArea/Detail'))
const GreylistAreaAddEdit = lazy(() => import('../pages/GreylistArea/AddEdit'))
const IsochroneVersioning = lazy(() => import('../pages/IsochroneVersioning'))
const AdjacentHub = lazy(() => import('../pages/AdjacentHub/List'))

type NamedRoutesType =
  | 'CloseMessageConfigRouter'
  | 'GlobalScheduledCloseRouter'
  | 'ServiceLevelRouter'
  | 'HubWeatherRouter'
  | 'BlacklistAreaRouter'
  | 'BlacklistAreaAddEditRouter'
  | 'BlacklistAreaDetailRouter'
  | 'GreylistAreaRouter'
  | 'GreylistAreaDetailRouter'
  | 'GreylistAreaAddEditRouter'
  | 'IsochroneVersioningRouter'
  | 'AdjacentHubRouter'
type PathListsType =
  | '/dashboard/location/close-message-config'
  | '/dashboard/location/global-scheduled-close'
  | '/dashboard/service-level'
  | '/dashboard/hub-weather'
  | '/dashboard/location/blacklist-area'
  | '/dashboard/blacklist-area'
  | '/dashboard/blacklist-area/:prefix/:id'
  | '/dashboard/blacklist-area-detail/:id'
  | '/dashboard/restricted-area'
  | '/dashboard/restricted-area-detail/:id'
  | '/dashboard/restricted-area/:prefix/:id'
  | '/dashboard/isochrone-versioning'
  | '/dashboard/adjacent-hub'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const CloseMessageConfigRouter: RouterInstanceType = {
  name: 'CloseMessageConfigRouter',
  Component: CloseMessageConfig,
  path: '/dashboard/location/close-message-config',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: CloseMessageConfigRBAC.pageID,
}

const GlobalScheduledCloseRouter: RouterInstanceType = {
  name: 'GlobalScheduledCloseRouter',
  Component: GlobalScheduledClose,
  path: '/dashboard/location/global-scheduled-close',
  routeType: 'PRIVATE',
  rbacPageID: GlobalScheduleCloseRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const ServiceLevelRouter: RouterInstanceType = {
  name: 'ServiceLevelRouter',
  Component: ServiceLevel,
  path: '/dashboard/service-level',
  routeType: 'PRIVATE',
  rbacPageID: ServiceLevelRBAC.pageID,
  isDashboard: true,
  allowedRoles: [],
}

export const HubWeatherRouter: RouterInstanceType = {
  name: 'HubWeatherRouter',
  Component: HubWeather,
  path: '/dashboard/hub-weather',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: HubWeatherRBAC.pageID,
}
export const BlacklistAreaRouter: RouterInstanceType = {
  name: 'BlacklistAreaRouter',
  Component: BlacklistArea,
  path: '/dashboard/blacklist-area',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: BlacklistAreaRBAC.pageID,
}

export const BlacklistAreaAddEditRouter: RouterInstanceType = {
  name: 'BlacklistAreaAddEditRouter',
  Component: BlacklistAreaAddEdit,
  path: '/dashboard/blacklist-area/:prefix/:id',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: BlacklistAreaAddEditRBAC.pageID,
}

export const BlacklistAreaDetailRouter: RouterInstanceType = {
  name: 'BlacklistAreaDetailRouter',
  Component: BlacklistAreaDetail,
  path: '/dashboard/blacklist-area-detail/:id',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: BlacklistAreaDetailRBAC.pageID,
}

export const GreylistAreaRouter: RouterInstanceType = {
  name: 'GreylistAreaRouter',
  Component: GreylistArea,
  path: '/dashboard/restricted-area',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: GreylistAreaRBAC.pageID,
}

export const GreylistAreaDetailRouter: RouterInstanceType = {
  name: 'GreylistAreaDetailRouter',
  Component: GreylistAreaDetail,
  path: '/dashboard/restricted-area-detail/:id',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: GreylistlistAreaDetailRBAC.pageID,
}

export const GreylistAreaAddEditRouter: RouterInstanceType = {
  name: 'GreylistAreaAddEditRouter',
  Component: GreylistAreaAddEdit,
  path: '/dashboard/restricted-area/:prefix/:id',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: GreylistAreaAddEditRBAC.pageID,
}

export const IsochroneVersioningRouter: RouterInstanceType = {
  name: 'IsochroneVersioningRouter',
  Component: IsochroneVersioning,
  path: '/dashboard/isochrone-versioning',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: IsochroneVersioningRBAC.pageID,
}

export const AdjacentHubRouter: RouterInstanceType = {
  name: 'AdjacentHubRouter',
  Component: AdjacentHub,
  path: '/dashboard/adjacent-hub',
  routeType: 'PRIVATE',
  isDashboard: true,
  allowedRoles: [],
  rbacPageID: AdjacentHubListRBAC.pageID,
}

const LocationRouter = [
  CloseMessageConfigRouter,
  GlobalScheduledCloseRouter,
  ServiceLevelRouter,
  HubWeatherRouter,
  BlacklistAreaRouter,
  BlacklistAreaAddEditRouter,
  BlacklistAreaDetailRouter,
  GreylistAreaRouter,
  GreylistAreaDetailRouter,
  GreylistAreaAddEditRouter,
  IsochroneVersioningRouter,
  AdjacentHubRouter,
]
export const LocationRouterDetail = generateRouterDetail(LocationRouter)

export default LocationRouter
